import React from "react";
import { DataFormControl } from "../DataFormControl";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { Box, Checkbox } from "@mui/material";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";

class XCheckboxEditUI extends React.Component<{ editMe: CheckboxFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                {this.props.editMe.renderBaseDataControlEditor()}

                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName={"defaultValue"}
                    label="Default Value"
                    onChange={() => {
                        this.props.editMe.setDefaultValue();
                    }}
                />
            </UISpacedBoxContent>
        );
    }
}

export class CheckboxFormControl extends DataFormControl {
    readonly __type: string = "Checkbox";
    defaultValue: boolean = false;

    render() {
        return (
            <Box
                alignItems={"center"}
                display={"flex"}
                flexDirection={"row"}
            >
                <Checkbox
                    name={this.label}
                    checked={this.getValue()}
                    onChange={this.handleChange}
                    data-testid={this.valueName}
                    inputRef={this.ref}
                />
                <UILabel paddingLeft={"5px"}>{this.label}</UILabel>
            </Box>
        );
    }

    componentDidMount() {
        if (this.valueName) {
            let val = this.getFormDataValue(this.valueName);
            if (val === null || val === undefined) {
                this.setFormDataValue(this.valueName, this.defaultValue);
            }
        }
    }

    setDefaultValue() {
        if (this.valueName) {
            let val = this.getFormDataValue(this.valueName);
            if (val === null || val === undefined) {
                this.setFormDataValue(this.valueName, this.defaultValue);
            }
        }
    }

    getValue(): boolean {
        if (this.valueName) {
            let val = this.getFormDataValue(this.valueName);
            if (val === undefined || val === null) {
                return this.defaultValue;
            }
            return val as boolean;
        }
        return this.defaultValue;
    }

    renderEditUI(): JSX.Element | null {
        return <XCheckboxEditUI editMe={this} />;
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let def = new BooleanDataDefinition();
        def.name = this.valueName;
        return def;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type", "defaultValue");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type", "defaultValue");
    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (this.valueName) {
            this.setFormDataValue(this.valueName, event.currentTarget.checked);
        }
    };
}
